import "@story/story_assets/dom_extend";

// Documentation:
// https://docs.packeta.com/docs/pudo-delivery/widget
// https://configurator.widget.packeta.com/cs


const packetaApiKey = "XXXa6b4848bf84247cb XXX XXX";
const packetaOptions = {
	country: "cz",
	language: "cs",
	valueFormat: "\"Packeta\",id,carrierId,carrierPickupPointId,name,city,street",
	view: "modal"
};

const storageKey = "#order_draft_shipping_destination_key";
const storageTitle = "#order_draft_shipping_destination_title";

function setValue(selector, value, triggerChange = false) {
	for (const element of document.querySelectorAll(selector)) {
		element.value = value;
	}

	// Trigger change event if needed.
	if (triggerChange) {
		for (const element of document.querySelectorAll(selector)) {
			element.trigger("change");
		}
	}
}

function showSelectedPickupPoint(point) {
	if (point) {
		setValue(storageTitle, point.name)

		// Trigger the change event only once after all values are set.
		// The change event is used to submit the form.
		setValue(storageKey, point.formatedValue, true)
	}
	else {
		setValue(storageTitle, "")
		setValue(storageKey, "", true)
	}
}

function openWidget() {
	Packeta.Widget.pick(packetaApiKey, showSelectedPickupPoint, packetaOptions)
}


document.addEventSelectorListener("click", ".packeta-selector-open", function(event, target) {
	event.preventDefault();
	openWidget();
});